import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
export default {
  loaded: state => state.loaded,
  user: state => Boolean(state.customer.user) && _objectSpread({}, state.customer.user, {
    user_type: state.customer.user_type,
    date_first_visit: state.customer.date_first_visit
  }),
  isConnected: state => Boolean(state.customer.user),
  cart: state => state.customer.cart,
  cartItems: state => state.customer.cartItems,
  cartSuccess: state => state.customer.cartSuccess
};